const textSplit = (text) => {
  if (text) {
    let split = '';
    const textArray = text.split('');
    textArray.map((e, i) => {
      return split += `<span class="split-text text-${i}">${e}</span>`;
    });
    return split;
  }
};

export default textSplit;


// WEBPACK FOOTER //
// ./src/scripts/util/textSplit.js